import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import Header from '@components/Comman/Header';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SendOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
// import BusiReferReferUsList from './BusiReferReferUsList';
// @ts-ignore
import { referuspageurl } from '../../environment'
import PageTitle from '@components/Comman/PageTitle';

import { referReferUsAction } from '../../actions/refer';
import SocialMediaCard from '../SocialMedia/SocialMediaCard';
import { businessDetailsAction } from '../../actions/business';
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';
// const { TextArea } = Input;

const ReferReferUs = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const user = useSelector((state: any) => state?.Auth);
    const userData = useSelector((state: any) => state?.Auth?.user?.user || state?.Auth?.user?.data);
    const businessDetails = useSelector((state: any) => state?.Business?.businessDetails);
    const [open, setOpen] = useState(false);

    useEffect(()=> {
        dispatch( businessDetailsAction({}, (resp: any) => {}) );
    }, [])


    const onFinish = (values: any) => {
        let referrerCode = userData?.roleId === 3 ? user?.user?.data?.referrerCode : user?.user?.data?.businessCode
        const payload = {
            companyName: values?.companyName,
            contactName: values?.contactName,
            position: values?.position,
            email: values?.email,
            mobileNumber: values?.mobileNumber,
            contactNumber: values?.contactNumber,
            address: values?.address,
            adminId : user?.user?.data?.id,
            referrerCode : referrerCode
        };


        dispatch(
            referReferUsAction(payload, (resp: any) => {
                if (resp?.status === 201) {
                //    navigate('/dashboard');
                setOpen(false)
                }
            })
        );

    };
    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };

    // const validateMobileInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    //     const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
    //     const regex = /^[0-9()+\s]$/; // Allow digits, (), +, and spaces

    //     if (!regex.test(event.key) && !allowedKeys.includes(event.key)) {
    //         event.preventDefault();
    //     }
    // };

    let url = userData?.roleId === 2 ?  `${referuspageurl}/refer-us/${userData?.businessCode}` : `${referuspageurl}/refer-us/${userData?.referrerCode}`
    let businessData = {
        ...businessDetails,
        business: {
            businessCode: userData?.businessCode,
            BusinessDetails: {
                businessName: userData?.businessDetails?.businessName,
                url: url,
                image: businessDetails?.logoUrl
            }
        },

    }
    return (
        <div>
            <Header pagTitle="Refer ReferUs" />
            <div className="contentBody">
                <div className="bodycard">
                    <PageTitle buttonLabel='Refer ReferUs' buttonClick={()=> setOpen(!open)} pagTitle="Refer ReferUs" button={false} />
                       
                    <Form
                        className="formControl"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                        onFinishFailed={onFailed}
                    >
                        <div className="row">
                            <div className="col-lg-6 col-sm-12">
                                <Form.Item
                                    name="companyName"
                                    className="formControlDesign"
                                    label="Business Name"
                                >
                                    <Input placeholder="Business Name" />
                                </Form.Item>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <Form.Item
                                    name="contactName"
                                    label="Contact Name"
                                    className="formControlDesign"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input contact!',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Contact Name" />
                                </Form.Item>
                            </div>
                            <div className="col-lg-6 col-sm-12">

                                <Form.Item
                                    name="email"
                                    label="Email Address"
                                    className="formControlDesign"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your email!',
                                        },
                                        {
                                            type: 'email',
                                            message: 'The input is not valid E-mail!',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Email Address" />
                                </Form.Item>
                            </div>
                            <div className="col-lg-6 col-sm-12">
                                <Form.Item
                                    name="position"
                                    label="Position"
                                    className="formControlDesign"
                                >
                                    <Input placeholder="Position" />
                                </Form.Item>
                            </div>
                            {/* <div className="col-lg-6 col-sm-12">
                                <CustomPhoneNumber isRequired={false} label="Mobile Number" name="mobileNumber" />
                            </div> */}
                            <div className="col-lg-6 col-sm-12">
                                <CustomPhoneNumber isRequired={false} label="Contact Number" name="contactNumber" />
                            </div>
                            <div className="col-lg-6 col-sm-12">

                                <Form.Item
                                    name="address"
                                    label="Address"
                                    className="formControlDesign"
                                >
                                    <Input placeholder="Enter Address" />
                                </Form.Item>
                            </div>


                            <div className="col-lg-12 mt-15">
                                <div className="text-end btn-groups-Forms">
                                    <button type='button' className="btn btn-outline-primary" onClick={()=> navigate('/dashboard')}>
                                        Cancel
                                    </button>
                                    <Button
                                        icon={<SendOutlined />}
                                        className="btn btn-primary"
                                        type="primary"
                                        onClick={() => form.submit()}
                                    >
                                        Refer
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>

                            <div className='mt-15'>
                                <SocialMediaCard extraTitle showQr={false} isPersonalBusiness={true} topTitle="Promote ReferUs to your network" userData={userData} userRole={userData?.roleId} className="social-media-card" isRefer={true} data={businessData} key={0} />
                            </div>
                    
                </div>

            </div>
        </div>
    );
};

export default ReferReferUs;
